<template>
  <div class="heatmap-svg"></div>
</template>
<script>

import h337 from 'heatmap.js'
export default {
  props: [
    'heatmap',
    'scale',
    'containerScale',
    'eventType'
  ],
  watch: {
    heatmap () {
      // console.log(this.heatmap)
      this.clearHeatmap()
      this.setHeatMap()
    },
    scale () {
      // console.log(this.eventType)
      // console.log(this.scale)
      this.clearHeatmap()
      this.setHeatMap()
    }
  },
  methods: {
    clearHeatmap () {
      const canvasEls = this.$el.getElementsByTagName('canvas')

      if (canvasEls.length) {
        canvasEls[0].parentNode.removeChild(canvasEls[0])
      }
    },
    setHeatMap () {
      this.isLoadedOnce = true
      const config = {
        container: this.$el,
        radius: 10 * this.containerScale,
        maxOpacity: 0.3,
        minOpacity: 0.06,
        blur: 0.75,
        gradient: {
          '0.2': 'blue',
          '0.35': 'cyan',
          '0.4': 'lime',
          '0.55': 'yellow',
          '0.63': 'orange',
          '0.9': 'red',
          '1': 'white'
        }
      }
      const heatmap = h337.create(config)
      const data = this.dataNormalizer(this.heatmap)
      const max = data.map(item => item.value).sort((a, b) => b - a)
      const maxValue = max[0]
      heatmap.setData({
        max: maxValue,
        data: data
      })
    },
    dataNormalizer (heatmap) {
      const data = []
      for (const xkey of Object.keys(heatmap)) {
        for (const ykey of Object.keys(heatmap[xkey])) {
          const value = heatmap[xkey][ykey]
          const x = Math.round(xkey * this.scale)
          const y = Math.round(ykey * this.scale)
          if (x && y) {
            data.push({
              x, y, value
            })
          }
        }
      }
      return data
    }
  }
}
</script>
<style scoped>
.heatmap-svg {
  height: 100%;
}
</style>
